import React, { useEffect, useState } from "react";
import { sortBy } from "lodash";

import Grid from "@mui/material/Grid2";

import { MediaScatterCard, MediaScoreCard, ScatterCard, ScoreCard } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { InsightResult, MediaScore } from "@/types";
import { filterItems } from "@/utils";

interface MediaViewProps {
  scores: InsightResult[];
  brandScores: InsightResult[];
}

const mediaQuintiles: {[name: string]: number} = {
  'Quintile 1 (Highest)': 3,
  'Quintile 2': 2,
  'Quintile 3': 1,
  'Quintile 4': -1,
  'Quintile 5 (Lowest)': -2,
  'None': -3,
}
const topQuintiles = ['Quintile 1 (Highest)', 'Quintile 2'];

const mediaBrands = [
  'Crunchyroll',
  'Spotify',
  'Disney+',
  'NOW',
  'Netflix',
  'YouTube',
  'Steam',
  'Google Play',
  'Audible',
  'The Telegraph',
  'discovery+',
  'Amazon Prime Video',
  'DAZN',
  'Playstation Network',
  'Channel 4',
  'Epic Games',
  'The Times',
  'The Guardian',
  'Magazines Direct',
  'Paramount+',
  'Sky Store',
  'Discord',
  'TV Licencing',
  'Roblox Corp',
  'Wikimedia',
  'Xbox',
  'itvX',
  'Oculus',
  'Amazon Music',
]

export const MediaView: React.FC<MediaViewProps> = ({ scores, brandScores }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [typeData, setTypeData] = useState<MediaScore[]>([]);
  const [brandData, setBrandData] = useState<InsightResult[]>([]);

  useEffect(() => {
    setTypeData(createMediaScores(filterItems(scores, scoreType.value)));
    setBrandData(filterItems(brandScores.filter(x => mediaBrands.includes(x.tag_name)), scoreType.value));
  }, [scores, brandScores, scoreType]);

  const createMediaScores = (data: InsightResult[]) => {
    const groups = Array.from(new Set(data.map(x => x.tag_category)));

    return sortBy(
      groups.map((group) => {
        const groupData = data.filter(x => x.tag_category === group);
        const topData = groupData.filter(x => topQuintiles.includes(x.tag_name))
        return (
        {
          tag_name: group,
          rate: topData.map(x => x.rate).reduce((a, b) => a + b, 0),
          score_wt: (groupData.slice(0, 3).map(x => mediaQuintiles[x.tag_name] * x.score_wt).reduce((a, b) => a + b, 0) / 3) + 3,
          score_rgn: (groupData.slice(0, 3).map(x => mediaQuintiles[x.tag_name] * x.score_rgn).reduce((a, b) => a + b, 0) / 3) + 3,
        })
      }),
      scoreType.value
    ).reverse()
  }

  return (
    <>
      <Grid container size={12} spacing={2}>
        <Grid size={6}>
          <MediaScoreCard
            name="Media Types"
            data={typeData}
            score={scoreType.value}
          />
        </Grid>
        <Grid size={6}>
          <ScoreCard
            name="Media Subscriptions"
            data={brandData}
            score={scoreType.value}
          />
        </Grid>
        <Grid size={6}>
          <MediaScatterCard
            title="Media Types"
            data={typeData}
          />
        </Grid>
        <Grid size={6}>
          <ScatterCard
            title="Media Subscriptions"
            data={brandData}
          />
        </Grid>

      </Grid>
    </>
  );
};

export default MediaView;
